import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthComponent } from './auth.component';
import {AuthRoutingModule} from './auth.routing.module';
import {AppTranslateModule} from '../core/translate/translate.module';
import {AuthService} from './auth.service';
import {HttpService} from './http.client.service';
import {XHRBackend, RequestOptions} from '@angular/http';
import {WindowService} from './window/window.service';
import {AuthGuard} from './auth-guard.service';
import {ProfileResolver} from './profile-resolver';
import {ServerStatusGuard} from './server-status.guard';
import {SiteGuard} from './site-guard';
import {UtilService} from "./util.service";
export function httpFactory(backend: XHRBackend, defaultOptions: RequestOptions, authService: AuthService, utilService: UtilService) {
  return  new HttpService(backend, defaultOptions, authService, utilService);
}

@NgModule({
  imports: [
    CommonModule,
    AuthRoutingModule,
    AppTranslateModule
  ],
  declarations: [AuthComponent],
  providers: [AuthService,
    AuthGuard,
    ServerStatusGuard,
    ProfileResolver,
    SiteGuard,
    {
    provide: HttpService,
    deps: [XHRBackend, RequestOptions, AuthService, UtilService],
    useFactory: httpFactory
  },
    UtilService,
    WindowService]
})
export class AuthModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth.module.ts